import {del, get, post, put} from './http'

/**
 * 获取雇员列表
 * @param params
 */
export const getEmployeeList = (params) => get('goodsmanual/role/list', params)

/**
 * 新增企业成员
 * @param params
 */
export const addAdminUser = (params) => post('goodsmanual/role', params)

/**
 * 新增客服成员
 * @param params
 */
export const addCustomerServiceUser = (params) => post('goodsmanual/role/service', params)

/**
 * 编辑企业成员
 * @param id
 * @param params
 */
export const editAdminInfos = (id, params) => put('goodsmanual/role/' + id, params)
/**
 * 编辑客服成员
 * @param id
 * @param params
 */
export const editCustomerServiceUserInfos = (id, params) => put('goodsmanual/role/service/' + id, params)

/**
 * 企业成员信息
 * @param id
 */
export const getAdminInfo = (id) => get('goodsmanual/role/ent/' + id, {})
/**
 * 客服成员信息
 * @param id
 */
export const getCustomerServiceUserInfo = (id) => get('goodsmanual/role/service/' + id, {})

/**
 * 删除成员
 * @param params
 */
export const delEmployee = (params) => del('goodsmanual/role', params)
/**
 * 删除客服
 * @param params
 */
export const delCustomerServiceUser = (params) => del('goodsmanual/role/service/list', params)

